import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export type RiskExposureCardTone = "danger" | "success" | "info";

const toneColors: Record<RiskExposureCardTone, { soft: string; strong: string }> = {
    danger: { soft: "#FDE7EC", strong: "#E1315A" },
    success: { soft: "#E4F6EC", strong: "#1F9D57" },
    info: { soft: "#E6ECFB", strong: "#2E5AAC" },
};

export const useRiskExposureCardStyles = (tone: RiskExposureCardTone) => {
    const theme = useTheme();
    const { soft, strong } = toneColors[tone];
    return createSxStyles({
        card: {
            position: "relative",
            minHeight: 200,
            padding: theme.spacing(3),
            display: "flex",
            flexDirection: "column",
            color: theme.palette.primary.dark,
        },
        icon: {
            position: "absolute",
            top: theme.spacing(3),
            right: theme.spacing(3),
            display: "flex",
            "& svg": { width: 60, height: 60 },
        },
        value: {
            fontSize: "2.5rem",
            fontWeight: theme.typography.fontWeightLight,
            lineHeight: 1,
            marginTop: theme.spacing(2),
        },
        pill: {
            alignSelf: "center",
            marginTop: "auto",
            display: "inline-flex",
            alignItems: "center",
            paddingY: 0.5,
            paddingX: 1.5,
            borderRadius: "999px",
            fontSize: theme.typography.pxToRem(14),
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: soft,
            color: strong,
        },
        pillArrow: {
            display: "inline-flex",
            alignItems: "center",
            marginRight: 0.75,
        },
    });
};
